import {
  GET_PROCESOS_REQUEST,
  GET_PROCESOS_SUCCESS,
  GET_PROCESOS_FAILURE,
  RESET_PROCESOS,
} from '../../constants/procesos/procesos.constants';

export const getProcesosAction = (page = 1, start = 0, limit = 99999, aprobado, archivado, tipoListado,
  sede, desdeNc, busqueda = null, procesosSeleccionados = []) => ({
  type: GET_PROCESOS_REQUEST,
  payload: {
    page, start, limit, aprobado, archivado, tipoListado, sede, desdeNc, busqueda, procesosSeleccionados,
  },
});

export const getProcesosSuccessAction = (datos, total, page, start, limit) => ({
  type: GET_PROCESOS_SUCCESS,
  payload: {
    datos, total, page, start, limit,
  },
});

export const getProcesosFailureAction = error => ({
  type: GET_PROCESOS_FAILURE,
  payload: error,
});

export const resetProcesos = () => ({
  type: RESET_PROCESOS,
});
